import { useTheme } from "@mui/material";
import { type ColorCieLab, deltaE } from "service/color-math";

export function useContrastBorder(...colors: Array<ColorCieLab | undefined>) {
  const white: ColorCieLab = [100, 0, 0];
  const showContrastBorder = colors.some(
    (color) => color && (deltaE(white, color) < 5 || color[0] > 96),
  );
  const contrastBorderColor = useTheme().palette.divider;
  return showContrastBorder ? `1px solid ${contrastBorderColor}` : undefined;
}
